



























































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import Alert from '@/components/Shared/Alert.vue';
import OpportunityDetails from '@/components/Opportunities/OpportunityDetails.vue';
import OpportunityStage from '@/components/Opportunities/Display/OpportunityStage.vue';
import OpportunityStatus from '@/components/Opportunities/Display/OpportunityStatus.vue';
import OpportunityStatusSet from '@/components/Opportunities/OpportunityStatusSet.vue';
import OpportunityStageSet from '@/components/Opportunities/OpportunityStageSet.vue';
import OpportunityConvert from '@/components/Opportunities/OpportunityConvert.vue';
import OpportunityClientTab from '@/components/Opportunities/OpportunityClientTab.vue';
import OpportunityVenueTab from '@/components/Opportunities/OpportunityVenueTab.vue';
import OpportunityContactTab from '@/components/Opportunities/OpportunityContactTab.vue';
import Documents from '@/components/Documents/Documents.vue';
import ActivityTimeline from '@/components/Activities/ActivityTimeline.vue';
import TaskGrid from '@/components/Activities/TaskGrid.vue';
import EntityType from '@/models/Shared/EntityType';
import ActivityEntityType from '@/models/Activities/ActivityEntityType';
import OpportunityStageEnum from '@/models/Opportunities/OpportunityStage';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';

@Component({
  name: 'AgencyOpportunity',
  components: { Alert, OpportunityDetails, OpportunityStage, OpportunityStatus, OpportunityStatusSet, OpportunityStageSet, OpportunityConvert, OpportunityClientTab, OpportunityVenueTab, OpportunityContactTab, Documents, ActivityTimeline, TaskGrid },
})
export default class extends GiganautVue {
  entityType = EntityType.Opportunity;
  activityEntityType = ActivityEntityType.Opportunity;

  get loading() { return OpportunityDetailsModule.loading; }
  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get showConvertWizard() { return OpportunityDetailsModule.showConvertWizard; }

  openWizard() { OpportunityDetailsModule.setShowConvertWizard(true); }
  closeWizard() { OpportunityDetailsModule.setShowConvertWizard(false); }

  // Won but not converted ⇒ show the yellow prompt with a "Convert now" button.
  // This catches API-only Won transitions and any case where the user dismissed
  // the convert dialog after marking Won.
  get needsConverting(): boolean {
    return !!this.opportunity
      && this.opportunity.stage === OpportunityStageEnum.Won
      && !this.opportunity.convertedAt;
  }

  async beforeMount() {
    const id = this.$route.params.opportunityId;
    if (id) {
      await OpportunityDetailsModule.load(id);
    }
  }
}
